<div class="row">
    <div class="col-md-8">
        <div class="modal-header justify-content-start">
            <div class="d-flex align-items-center">

                 <i title="Search" class="material-icons-outlined text-info" style="cursor: pointer;"
                    (click)="toggleFreezeOptions()">keyboard_double_arrow_right</i>

                <i title="Group By Options" class="material-icons text-info" style="cursor: pointer;"
                    (click)="toggleGroupByOptions()">group</i>

                <div class="d-flex justify-content-end mb-2">
                    <i class="material-icons text-info"
                        [ngClass]="{ 'text-info': isDrilldownMode, 'text-muted': !isDrilldownMode }"
                        title="Toggle Drilldown Mode" (click)="toggleDrilldownMode()" style="cursor: pointer;">arrow_circle_down
                    </i>
                </div>


                <div class="search-box mx-1 mb-2">
                    <input [(ngModel)]="searchText" (ngModelChange)="filterData()" placeholder="&#61442; Search."
                        class="form-control px-4">
                </div>
                <div class="d-flex align-items-center">
                    <select class="form-control mb-2 mx-1" [(ngModel)]="selectedGroupColumn"
                        (change)="groupBySelectedColumn()">
                        <option value="">Ungroup</option>
                        <option *ngFor="let col of gridColumnDetails" [value]="col.prop">{{ col.name }}</option>
                    </select>

                    <select *ngIf="showGraphType" class="form-control mb-2 mx-1" [(ngModel)]="selectedChartType"
                        (change)="onChartTypeChange()">
                        <option value="">Select Chart Type</option>
                        <option value="Pie">Pie</option>
                        <option value="Bar">Bar</option>
                        <option value="Line">Line</option>
                    </select>
                    <select *ngIf="showNumericColum" class="form-control mb-2 mx-1" [(ngModel)]="selectedNumericColumn"
                        (change)="onNumericColumnChange()">
                        <option value="">Select Numeric Column</option>
                        <option *ngFor="let col of numericColumns" [value]="col.prop">{{ col.name }}</option>
                    </select>
                    <select *ngIf="showNumericColum" class="form-control mb-2 mx-1" [(ngModel)]="selectedDateColumn">
                        <option value="">Select Date Column</option>
                        <option *ngFor="let col of dateColumns" [value]="col.prop">{{ col.name }}</option>
                    </select>
                    <i *ngIf="showMakeGraph" title="Make Graph" class="iconsminds-pie-chart fs-22 text-warning mx-1 mb-2"
                        (click)="makeGraph()" (click)="ShowChart(showChart)">
                    </i>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4">
        <div class="modal-header justify-content-end align-items-center">
            <div class="d-flex align-items-center">
                <input title="Negatives Row" class="form-check-input" type="checkbox"(change)="onHighlightNegativeRowsChange($event)" />
                <input title="Highlight Negatives" class="form-check-input" type="checkbox" id="highlightNegatives" [(ngModel)]="highlightNegatives" />
                <i *ngIf="showGraphType && !showOnlyGroupTotals" title="Summary" class="iconsminds-add-file text-info" (click)="showGroupTotalsOnly()"></i>
                <i *ngIf="showGraphType && showOnlyGroupTotals" title="Show All Rows"  class="iconsminds-add-file text-danger" (click)="showAllRows()"></i>
                <i title="Print" class="iconsminds-printer text-dark" (click)="printTable()"></i>
                <i title="Export Excel" class="iconsminds-download text-success" (click)="exportExcel()"></i>
                <i title="Search" class="iconsminds-mail-search text-info" (click)="toggleSearch(showSearch)"></i>
            </div>
        </div>
    </div>
</div>
<div class="table-responsive card" style="max-height: 530px; overflow-y: auto;">
    <table class="table table-bordered">
        <thead class="bg-light sticky-top" style="top: 0; z-index: 1;">
            <tr class="text-light fw-bold text-uppercase">
                <th *ngFor="let col of gridColumnDetails; let j = index"
                    (dragstart)="onDragStart($event, j)" (dragover)="onDragOver($event)" (drop)="onDrop($event, j)"                    
                    [ngStyle]="{ 'min-width.px': columnWidths[j], 'width.px': columnWidths[j] }"
                    style="cursor: pointer;" [class.frozen]="isColumnFrozen(j)" [style.left.px]="getLeftOffset(j)">
                    <div (click)="onSort(col.prop)" style="display: inline-grid; width: 100%;"
                        [style.textAlign]="getHeaderAlignment(col.prop)">
                        {{ col.name }}
                    </div>
                    <input *ngIf="showSearch" type="text" class="form-control mt-1 filterinput"
                        (keyup)="keyupColumnSearch($event, col.prop)" />

                    <div class="form-check mt-1" *ngIf="showFreezeOptions">
                        <input class="form-check-input" type="checkbox" [checked]="frozenColumns.has(j)"
                            (change)="toggleFreezeColumn($event, j)" />
                    </div>

                    <div class="form-check mt-1" *ngIf="showGroupByOptions">
                        <input class="form-check-input" type="checkbox" [checked]="selectedGroupBy.includes(col.prop)"
                            (change)="onGroupByChange(col.prop, $event)" />
                    </div>

                </th>
            </tr>
        </thead>
        <tbody *ngIf="!isGrouped">
            <tr *ngFor="let row of filteredData; let i = index" [class.fw-bold]="row.isTotalRow"
                [class.text-primary]="row.isTotalRow" [class.bg-primary-subtle]="row.isTotalRow"
                [ngClass]="getRowClasses(row)">
                <td *ngFor="let col of gridColumnDetails; let j = index" (click)="handleCellClick(row, col)"
                    (click)="onColumnCellClick(col.prop)"
                    [ngStyle]="{'text-align': isNumeric(row[col.prop]) ? 'right' : 'left' }"
                    [class.frozen]="isColumnFrozen(j)" [style.left.px]="getLeftOffset(j)"
                    [ngClass]="{'text-danger bg-danger-subtle': highlightNegatives && isNumeric(row[col.prop]) && row[col.prop] < 0}"
                    [ngbTooltip]="isNumeric(row[col.prop]) ? totalGraphTeam[i] : row[col.prop]"
                    [placement]="getTooltipPlacement(row, col.prop, i)" container="body">
                    {{ isNumeric(row[col.prop]) ? formatNumberWithCommasNBracket(row[col.prop]) : row[col.prop] }}
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="isGrouped">
            <ng-container *ngFor="let group of groupedData">
                <!-- Parent -->
                <tr class="fw-bold text-primary bg-primary-subtle">
                    <td *ngFor="let col of gridColumnDetails">
                        <ng-container *ngIf="selectedGroupBy.includes(col.prop)">
                            <ng-container *ngIf="col.prop === 'productImage'; else normalParent">
                                <img [src]="group[col.prop]" width="100"
                                    style="width: 100px; height: auto; object-fit: contain;" />
                            </ng-container>
                            <ng-template #normalParent>
                                {{ group[col.prop] }}
                            </ng-template>
                        </ng-container>
                    </td>
                </tr>

                <!-- Children -->
                <tr *ngFor="let child of group.childRows" class="bg-light">
                    <td *ngFor="let col of gridColumnDetails">
                        <ng-container *ngIf="!selectedGroupBy.includes(col.prop)">
                            {{ child[col.prop] }}
                        </ng-container>
                    </td>
                </tr>
                <tr class="table-secondary fw-bold">
                    <td *ngFor="let col of gridColumnDetails; let i = index">
                        <ng-container *ngIf="group.totals[col.prop] !== undefined; else emptyCell">
                            {{ group.totals[col.prop] }}
                        </ng-container>
                        <ng-template #emptyCell>
                            <ng-container *ngIf="i === 0">Group Total:</ng-container>
                        </ng-template>
                    </td>
                </tr>

            </ng-container>
        </tbody>
    </table>
</div>
<div class="bg-primary-subtle text-primary fs-18 d-flex justify-content-between">
    <p class="m-0 text-start text-dark fw-blod" style="padding: 4px;">
        Total Rows: {{filteredData.length - 1 }}
    </p>
    <p class="m-0 text-center px-3" style="padding: 4px;">Total: {{ totalProduction }}</p>
</div>
<!-- print table -->
<div id="printTileDetail" style="display: none;">
    <table class="table table-bordered">
        <thead>
            <tr>
                <th *ngFor="let col of gridColumnDetails">{{ col.name }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of filteredData">
                <td *ngFor="let col of gridColumnDetails">{{ row[col.prop] }}</td>
            </tr>
        </tbody>
    </table>
</div>
<ng-template #showChart let-modal>
    <div class="modal-content ">
        <div class="modal-header justify-content-between p-0">
            <div class="d-flex justify-content-start">
                <select *ngIf="showGraphType" class="form-select mb-2 mx-1" [(ngModel)]="selectedChartType"
                    (change)="onChartTypeChange()">
                    <option value="">Select Chart Type</option>
                    <option value="Pie">Pie</option>
                    <option value="Bar">Bar</option>
                    <option value="Line">Line</option>
                </select>
                <select *ngIf="showNumericColum" class="form-select mb-2 mx-1" [(ngModel)]="selectedNumericColumn"
                    (change)="onNumericColumnChange()">
                    <option value="">Select Numeric Column</option>
                    <option *ngFor="let col of numericColumns" [value]="col.prop">{{ col.name }}</option>
                </select>
                <select *ngIf="showNumericColum" class="form-select mb-2 mx-1" [(ngModel)]="selectedDateColumn">
                    <option value="">Select Date Column</option>
                    <option *ngFor="let col of dateColumns" [value]="col.prop">{{ col.name }}</option>
                </select>
                <i *ngIf="showMakeGraph" title="Make Graph" class="ri-pie-chart-2-fill fs-22 text-warning mx-1 mb-2"
                    (click)="makeGraph()">
                </i>
            </div>
            <div class="modal-footer p-0">
                <a href="javascript:void(0);" class="btn btn-link link-success fw-medium" data-bs-dismiss="modal"
                    (click)="modal.close('Close click')"><i class="ri-close-line me-1 align-middle"></i> Close</a>
            </div>
        </div>
        <!-- graph  -->
        <div class="row">
            <div class="col-lg-12">
                <div *ngIf="showChart">
                    <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart"
                        [labels]="chartOptions.labels" [xaxis]="chartOptions.xaxis"
                        [dataLabels]="chartOptions.dataLabels" [title]="chartOptions.title"></apx-chart>
                </div>
            </div>
        </div>
        <!--Summary Table  -->
        <div class="table-responsive mt-3">
            <h5 class="fw-bold">Summary Table</h5>
            <table class="table table-bordered table-striped text-center">
                <thead class="bg-light sticky-top" style="top: 0; z-index: 1;">
                    <tr class="text-uppercase text-light fw-bold">
                        <th (click)="onSummarySort('group')" style="cursor: pointer;">
                            {{ selectedGroupColumn }}
                        </th>
                        <th (click)="onSummarySort('value')" style="cursor: pointer;">
                            {{ selectedNumericColumn }}
                        </th>
                        <th *ngIf="selectedDateColumn" (click)="onSummarySort('date')" style="cursor: pointer;">
                            {{ selectedDateColumn }}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let row of summaryTableData"
                        [ngClass]="{ 'fw-bold text-primary fs-6': row.group === 'Total' }">
                        <td>{{ row.group }}</td>
                        <td>{{ formatNumberWithCommasNBracket(row.value) }}</td>
                        <td *ngIf="selectedDateColumn">{{ row.date }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-template>